import { JobApplication } from "../Entities/job-application.entity";
import apiClient from "./api-client.service";
import AuthService from "./auth.service";
import googleAnalyticService from "./google.analytic.service";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "";

class JobApplicationService {
  private static instance: JobApplicationService;

  constructor() {
    if (JobApplicationService.instance) {
      return JobApplicationService.instance;
    }
    JobApplicationService.instance = this;
  }

  async sendJobApplication(
    jdId: string,
    appliedJobs: JobApplication[],
    orgName: string,
    jobPostName: string
  ) {
    const currentUser = AuthService.getInstance().getCurrentUser();
    if (!currentUser) {
      return;
    }

    try {
      const alreadyApplied = appliedJobs.some(
        (job: JobApplication) => job._id === jdId
      );
      if (alreadyApplied) {
        console.warn(`Job with ID ${jdId} is already applied.`);
        return;
      }

      const applicationResponse = await apiClient.post(
        `${API_BASE_URL}/job-description/${jdId}/application`
      );

      if (!applicationResponse?.data) {
        console.error("No data returned from job application response.");
        return;
      }

      googleAnalyticService.handleSubmissionEvents({
        category: "QualifyMe Candidate Job Application Submission",
        action: `job_application_submitted`,
        user_first_name: currentUser?.firstName,
        organization_name: orgName,
        job_post_name: jobPostName,
        user_id: currentUser._id,
        label: `Job Application submitted for job post ${jobPostName} by user ${currentUser._id} to organization ${orgName}`,
      });
      return applicationResponse.data;
    } catch (error) {
      console.error("Error applying for job:", error);
    }
  }

  async getJobApplicationByJobDescriptionId(
    jdId: string
  ): Promise<JobApplication> {
    const response = await apiClient.get(
      `${API_BASE_URL}/job-description/${jdId}/application`
    );
    return response.data[0];
  }

  async findJobApplicationById(
    id: string
  ): Promise<JobApplication | undefined> {
    if (!AuthService.getInstance().getCurrentUser()) {
      return;
    }
    const response = await apiClient.get(
      `${API_BASE_URL}/job-description/application/${id}`
    );
    return response?.data;
  }

  async findAllJobApplicationByUserId(
    userId: string
  ): Promise<JobApplication[]> {
    try {
      const response = await apiClient.get(
        `${API_BASE_URL}/job-description/application/all/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching job applications:", error);
      return [];
    }
  }

  async getUserInterviewSessions(
    userId: string
  ): Promise<any[]> {
    try {
      const response = await apiClient.get(
        `${API_BASE_URL}/interview/sessions/user/${userId}`
      );
      return response.data || [];
    } catch (error) {
      console.error("Error fetching interview sessions:", error);
      return [];
    }
  }
}

export default JobApplicationService;
